import { Module, VuexModule, Action } from "vuex-module-decorators";
import store from "../store";
import Vue from "vue";
import { shutdownMessenger, startMessenger } from "@/services/tawkToMessengerService";

/**
 * 👾 Module which handles general purpose functionality for the application
 */
@Module
export default class GlobalModule extends VuexModule {
  /**
   * 🚮 Clears the whole user configuration
   */
  @Action
  public prepareUserForLogout() {
    Vue.axios.defaults.headers.common["Authorization"] = "";
    this.context.dispatch("resetState");
    startMessenger(null);
  }

  /**
   * 🚮 Resets the Vuex state
   */
  @Action
  public resetState() {
    store.replaceState({
      authorization: {
        authorizationToken: undefined,
        isAuthorized: false,
        is2FAEnabled: undefined,
        secretQuestion: undefined,
      },
      snackbar: {},
      global: {},
      exchanges: {
        connectedExchanges: [],
        exchangesData: undefined,
        loading: false,
        isExchnageConnected: false,
      },
      userData: {
        username: undefined,
        email: undefined,
        isUserEmailVerified: true,
        createdOn: undefined
      },
      notifications: {
        unreadNotifications: undefined,
        notifications: [],
        page: undefined,
        totalPages: undefined,
      },
      notificationPreferences: {},
      publicBotStats: {
        botTypesStats: [],
        selectedTimePeriodInSeconds: -1 * 3600,
        generalBotsStatsAreLoading: false,
        lastUpdateTime: undefined
      },
      eventbus: {},
      bots: {
        botsPerExchanges: [],
        totalBotsStats: undefined,
        allBots: [],
      },
      payments: {
        currentPaymentMethod: undefined,
        currentSubscription: undefined,
        profitabilityByBot: [],
        subscriptionInvoices: [],
      },
      subscription: {
        currentSubscriptionPlan: undefined,
        availableSubscriptionPlans: [],
      },
      userPreferences: {
        censorSensitiveData:
          store.state.userPreferences.censorSensitiveData !== undefined
            ? store.state.userPreferences.censorSensitiveData
            : false,
        darkMode:
          store.state.userPreferences.darkMode !== undefined
            ? store.state.userPreferences.darkMode
            : false,
        showDashboardCoinAmount:
          store.state.userPreferences.showDashboardCoinAmount !== undefined
            ? store.state.userPreferences.showDashboardCoinAmount 
            : true,
        showDetailedDashboardDonutChart:
          store.state.userPreferences.showDetailedDashboardDonutChart !== undefined
            ? store.state.userPreferences.showDetailedDashboardDonutChart
            : false,
        liteMode: store.state.userPreferences.liteMode !== undefined
          ? store.state.userPreferences.liteMode
          : undefined,
        selectedDashboardTimeFrame: store.state.userPreferences.selectedDashboardTimeFrame !== undefined
          ? store.state.userPreferences.selectedDashboardTimeFrame
          : null,
      },
      shared: {
        appBarLoading: false,
      },
      wallet: {
        depositWalletAddress: undefined,
        hotWalletBalance: undefined,
        coldWalletBalance: undefined,
        currentOBTPrice: undefined,
        lastUpdateTime: undefined,
        walletTransactions: [],
        estimatedFees: undefined,
        OBTHoldingRank: undefined,
      },
      holdingTiers: {
        allOBTHoldingTiers: [],
        currentOBTHoldingTier: undefined,
      },
      nft: {
        nftWallet: undefined,
        extraNFTBotSlots: undefined,
        nftCollection: [],
        nftWalletAddressVisible: true,
        activeNFTSkins: {
          astral: undefined,
          clipper: undefined,
          endeavour: undefined,
          horizon: undefined,
          performer: undefined,
        },
      },
    });
  }
}
